import { SUBSCRIPTION_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  personalData: {
    title: "Personal Data",
    fields: {
      name: "Name",
      surnames: "Surnames",
      address: "Address",
      email: "Email",
      phone: "Phone",
      birthDate: "Date of Birth",
      curp: "CURP",
    },
  },
  credentialInfo: {
    title: "Credential information",
    fields: {
      voterKey: "Voter Key",
      section: "Section",
      validity: "Validity",
    },
    modify: "Modify",
    needModify: {
      title: "Do you need to modify your INE?",
      description:
        "If you need to modify any INE data (change of municipality, renewal due to expiration, theft or loss) you will have to:",
      bullet1: "Perform said procedure on the",
      officialPage: "official page",
      bullet2:
        'Once the change has been made and the INE with updated data has been obtained, click on the "validate" button.',
    },
    validate: {
      title: "Validate",
      description:
        "Once the change has been made and the new INE credential with updated data has been obtained, click on the following button",
      button: "Validate",
    },
    validateModal: {
      title: "Validate INE",
      message:
        "You are about to start the verification process for your new INE credential. You will be redirected to the verification service to validate your identity.",
      confirm: "Yes, validate",
      cancel: "Cancel",
      redirecting: "Redirecting...",
    },
  },
  verifications: {
    title: "Verifications",
    kyc: "KYC",
    wallet: "Wallet",
    subscription: "Subscription",
    subscriptionActive: "Active",
    subscriptionInactive: "Inactive",
  },
  walletSection: {
    title: "Account",
    viewInExplorer: "View in explorer",
    noWallet: "No wallet connected",
    poweredBy: "Powered by HumanWallet, developed",
    poweredByLink: "by Tutellus",
  },
  themeSection: {
    light: "Dark mode",
    dark: "Light mode",
  },
  userSection: {
    title: "User",
    wallet: {
      infoTitle: "Do not share your address",
      infoMessage: "Your address is only known to you. Do not share it with anyone, they could see your votes",
    },
    transactions: {
      title: "Transactions",
      infoTitle: "Transaction detail",
      infoMessage:
        "Click on the transaction you want and we will redirect you to see the transaction detail on the blockchain",
      empty: "No transactions recorded",
    },
  },
  subscriptionSection: {
    title: "Subscription",
  },
  notificationsSection: {
    title: "Notifications",
  },
  subscription: {
    type: "Annual",
    subscriptionType: "Subscription type",
    price: "Price",
    status: "Status",
    statuses: {
      [SUBSCRIPTION_STATUS_ENUM.PENDING]: "Pending",
      [SUBSCRIPTION_STATUS_ENUM.APPROVAL_PENDING]: "Approval Pending",
      [SUBSCRIPTION_STATUS_ENUM.ACTIVE]: "Active",
      [SUBSCRIPTION_STATUS_ENUM.SUSPENDED]: "Suspended",
      [SUBSCRIPTION_STATUS_ENUM.CANCELLED]: "Cancelled",
      [SUBSCRIPTION_STATUS_ENUM.EXPIRED]: "Expired",
    },
    timeRemaining: "Time remaining",
    days: "days",
    autoRenewal: "Automatic renewal",
    yes: "Yes",
    no: "No",
    startDate: "Start date",
    endDate: "End date",
    nextBillingDate: "Next billing date",
    cancelSubscription: "Cancel subscription",
    getSubscription: "Get subscription",
    getButton: "GET",
    reactivateButton: "Reactivate renewal",
    continue: "Continue",
    loading: "Loading...",
    noSubscription: "You don't have any active subscription",
    confirmCancel: {
      title: "Are you sure?",
      message:
        "If you cancel your subscription it will not be renewed, so when it ends you will not be able to continue voting",
      confirm: "Cancel subscription",
      cancel: "Go back",
    },
    checkout: {
      title: "Complete your purchase",
      summary: "Summary",
      selectPayment: "Choose your payment method",
      mercadopago: "Mercado Pago",
      mercadopagoDescription: "Pay securely with Mercado Pago",
      card: "Card",
      cardDescription: "Pay securely with your debit or credit card",
      paypal: "PayPal",
      paypalDescription: "Pay securely with your PayPal account",
      payButton: "PAY",
      renewalNote: "The subscription will renew automatically, but you can cancel it anytime.",
    },
    reviewer: {
      status: "Active (review account)",
    },
    pendingApproval: {
      title: "Your payment is pending",
      message:
        "You started a payment with {{provider}} but it wasn't completed. You can continue where you left off or cancel and pick another method.",
      continueButton: "Continue payment",
      cancelButton: "Cancel and start over",
    },
    error: "Error loading subscription",
    cancelError: "Error canceling subscription",
    cancelSuccess: "Subscription canceled successfully",
  },
  participationSection: {
    title: "Participation",
    navLabel: "Participation role",
    noRole: "No role assigned",
    roles: {
      REPRESENTATIVE: "Representative",
      NOTARIO_CIUDADANO: "Citizen Electoral Notary",
      NONE: "None",
    },
  },
  faqSection: {
    title: "Frequently asked questions",
  },
  contact: {
    title: "Need help?",
    button: "Contact",
  },
  disconnect: "Disconnect",
  disconnectModal: {
    title: "Log out",
    message: "You are about to log out with the email",
    confirm: "Yes, log out",
    cancel: "Cancel",
  },
}
